import { Typography } from '@material-ui/core';
import type { CockpitContextNotice } from '../model/cockpitPresentationPolicy';
import { useCockpitStyles } from './cockpitStyles';

export interface ContextualNoticeProps {
  label: string;
  notice: CockpitContextNotice;
}

export const ContextualNotice = ({ label, notice }: ContextualNoticeProps) => {
  const classes = useCockpitStyles();
  return (
    <div
      role="note"
      aria-label={label}
      className={`${classes.contextualNotice} ${
        notice.tone === 'error' ? classes.contextualNoticeError : ''
      }`}
    >
      <Typography component="p" variant="body2">
        <strong>{notice.summary}</strong>
        {notice.impact ? ` ${notice.impact}` : ''}
        {notice.action ? ` Próxima ação: ${notice.action}` : ''}
      </Typography>
    </div>
  );
};
